module.exports = __webpack_public_path__ + "img/6@3x.9e562ae2.png";